//   获取删除节点
      let the_button=$("#scriptClass").attr("data-id");
  function getUrlParam(name) {    
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); 
    var r = window.location.search.substr(1).match(reg);  
    if(r != null) return unescape(r[2]);    
    return null;
  }
  var orderId = getUrlParam("id")
  
  $.ajax({  
    type : "get",  
    url : "https://prisrv.uniprocessing.com/omniPersonalizerRelease/front/theme/getThemeName",
//     async : false,
    success : function(data){ 
      //   获取json
     let cusThemeName = data;
      $.ajax({  
        type : "get",  
        url : "https://"+window.location.host+"/cart.js", 
        //       url : "https://"+window.location.host+"/cart/add.js",  
        dataType:"text",
        async : false,
        success : function(data){ 
          let obj = JSON.parse(data),
              conALL=[];
          console.log(obj)
          obj.items.map((tokes,index)=>{
            if(tokes.properties) {
              if(tokes.properties.token){
              	$.ajax({  
                  type : "get",  
                  url : "https://prisrv.uniprocessing.com/omniPersonalizerRelease/front/customerDesignOrderItem/list?token="+tokes.properties.token,  
                  dataType:"text",
                  async : false,
                  success : function(suc){
                    JSON.parse(suc)
                    let con='';
                    con+='<li class=" suf-pro product-details__item product-details__item--property" data-cart-item-property>';
                    JSON.parse(suc).map((surface,surindex)=>{
                      con+='<div class="sufFather">'+
                        ' <p class="suf" ><span class="blod">+</span>'+surface.surfaceName+'  Customization Info</p>'+
                        '</div>'; 

                      con+='<div class="hide suf-pro">'+
                        '<div class="lookImg mt10 flex flex_end">'+
                        '<img  style="width:90px;" src="https://prisrv.uniprocessing.com/omniPersonalizerRelease/resource'+surface.finalImage+'">'+
                        '<p data-cart-item-property-value><svg t="1686797117091" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="975" width="200" height="200"><path d="M143.12315656 143.35723719C75.6695047 210.81664438 38.52452375 300.50893437 38.52452375 395.90550406c0 95.39848875 37.14498187 185.08981875 104.60534812 252.551145 67.45269187 67.46516344 157.14498188 104.61014531 252.54922593 104.61014531 64.62645375 0 126.59743406-17.09173781 180.84854345-49.06583531L849.12819312 976.58903937a29.60259 29.60259 0 0 0 20.89746938 8.6581125c7.8196425 0 15.34956187-3.12363562 20.89746938-8.6581125l85.87408593-85.88080124a29.46828187 29.46828187 0 0 0 8.67825844-20.89746938 29.4375825 29.4375825 0 0 0-8.67825845-20.889795L704.09017906 576.22736563c31.75632562-54.12543469 48.75596625-115.91221969 48.75596532-180.32186157 0-95.39657063-37.1574525-185.08885969-104.60534814-252.54826687-67.45940719-67.45940719-157.1574525-104.60438906-252.56169843-104.60438906s-185.09653405 37.14498187-252.55594125 104.60438906zM914.11919937 869.81076875l-44.09257781 44.10025219-244.58376281-244.60486875c7.81964251-6.61662094 15.45413156-13.5325575 22.79889656-20.84950312 7.47715593-7.47043969 14.53027969-15.27089625 21.24187594-23.27569219L914.11919937 869.81076875zM606.44777562 185.13778625c56.29835719 56.29835719 87.30063562 131.15721281 87.30063563 210.76771781 0 79.61434219-31.00227844 154.47127969-87.30063563 210.75620625-56.29931625 56.29835719-131.1552947 87.287205-210.76867781 87.28720407s-154.47032062-30.98980687-210.76196156-87.28720407c-56.29164188-56.28492655-87.287205-131.14090406-87.287205-210.75620625 0-79.61050501 30.99556313-154.47032062 87.287205-210.76771781S316.06667469 97.84962219 395.67909781 97.84962218s154.46936062 30.98980687 210.76867781 87.28816407z" fill="#474747" p-id="976"></path><path d="M431.00035999 161.91677656c-2.4971822 10.59407625 4.05516281 21.21405469 14.63580751 23.7237075 38.88811594 9.19438781 74.44825501 29.07303 102.83439281 57.46108688 40.84326656 40.81736437 63.32557875 95.09341688 63.32557875 152.80393312 0 57.72586688-22.48231219 111.98848782-63.32557875 152.8125675a217.72586625 217.72586625 0 0 1-23.06367656 20.05228499c-8.67825844 6.53219812-10.44921469 18.86940844-3.89687062 27.58124439 6.551385 8.68497375 18.88859531 10.44825563 27.59371593 3.88343906a255.0109125 255.0109125 0 0 0 27.22532719-23.66422781c48.29260125-48.25422751 74.84446594-112.41156 74.84446594-180.66530813 0-68.23935749-26.55186469-132.40916156-74.83103532-180.6499575-33.56469563-33.57908625-75.62345625-57.0773475-121.64528062-67.94867532-10.57297031-2.53651501-21.1871925 4.04173125-23.69684626 14.60990532zM461.2764125 601.86017469c-77.360835 24.5631375-161.04856687 4.20769875-218.40316594-53.14210313-40.80297375-40.82407968-63.286245-95.08670063-63.28624594-152.8125675 0-57.71051719 22.48327125-111.98656875 63.29967656-152.80393312 27.5409525-27.55534219 61.9517925-47.14522125 99.50545594-56.668665 10.53459656-2.66794594 16.92864844-13.35411937 14.26645875-23.92229344-2.67466125-10.5547425-13.39441219-16.93440469-23.94243843-14.25302812-44.42930812 11.25506625-85.14114375 34.41084094-117.70140375 66.99892125-48.2542275 48.24079594-74.83103531 112.41060094-74.83103438 180.64995843 0 68.2537472 26.57776687 132.41108062 74.83103438 180.66530719 67.80381376 67.79709844 166.74133594 91.88343937 258.19019062 62.84302688 8.38757625-2.67466125 13.74361406-10.42139344 13.743615-18.77059593 0-1.98776813-0.2973975-3.98896781-0.93152719-5.9824922-3.29535937-10.3571175-14.3719875-16.09785375-24.74061562-12.80153531z" fill="#474747" p-id="977"></path><path d="M226.41371844 356.727665c-2.47032 10.61997844 4.16069062 21.16224938 14.7681975 23.63161031 10.60079156 2.44345875 21.18143625-4.17508125 23.61817968-14.76915656 5.64000469-24.463365 18.05012625-46.8132872 35.89591125-64.67154375a19.65031781 19.65031781 0 0 0 5.76567938-13.93644281 19.66662656 19.66662656 0 0 0-5.76567938-13.92397219c-7.70068313-7.68629344-20.17028437-7.68629344-27.86521218 0-23.06943281 23.09245687-39.12507469 52.02062625-46.41707625 83.669505zM382.31730406 262.25494625c10.17100406-1.00443656 17.77287469-9.56373656 17.77287469-19.60330969 0-0.63316968-0.0326175-1.29511969-0.10552875-1.92828844-1.0696725-10.83199406-10.70631937-18.75812438-21.53063906-17.67502124a174.03813375 174.03813375 0 0 0-38.96774156 8.42786906c-10.29667781 3.51313125-15.8052525 14.68857187-12.2978775 24.99196594 3.50065969 10.33025531 14.69528719 15.79949625 24.98524968 12.31226718a134.80273406 134.80273406 0 0 1 30.1436625-6.52548281z" fill="#474747" p-id="978"></path></svg></p>'+
                        '</div>'+
                        '<div class="model hide">'+
                        '<div class="showPic3"><img class="mt50" src="https://prisrv.uniprocessing.com/omniPersonalizerRelease/resource'+surface.finalImage +'" style="width:90%;"></a></div>'+
                        '</div>'+
                        '</div>';

                    });

                    con+='<li>';
                    if(cusThemeName === 'Debut' || cusThemeName === 'Simple'|| cusThemeName === 'Boundless' || cusThemeName === 'Venture') {
                      $(".cart tbody .cart__row").eq(index).find("a").each(function(){
                        if($(this).text() == "Remove" ) {
                          $(this).before("<ul class='ajaxcart_url ajaxcart__product-meta' style='margin:0;list-style: none;padding:0;'>"+con+"</ul>");
                        }
                      })
                    } else if (cusThemeName === 'supply') {
                      console.log(con)
                        $(".cart-form .cart-row").eq(index).each(function(){
                            $(this).find(".two-thirds").append("<ul class='ajaxcart_url ajaxcart__product-meta' style='margin:0;list-style: none;padding:0;'>"+con+"</ul>");
                        })
                    } else if (cusThemeName === 'Narrative') {
                      console.log(con)
                        $(".cart__form .cart-item").eq(index).each(function(){
                            $(this).find(".cart-item__meta").append("<ul class='ajaxcart_url ajaxcart__product-meta' style='margin:0;list-style: none;padding:0;'>"+con+"</ul>");
                        })
                    }else if (cusThemeName === 'Brooklyn') {
                      console.log(con)
                        $(".cart .cart__row").eq(index+1).each(function(){
                            $(this).find(".two-thirds").append("<ul class='ajaxcart_url ajaxcart__product-meta' style='margin:0;list-style: none;padding:0;'>"+con+"</ul>");
                        })
                    }else if (cusThemeName === 'Express') {
                      console.log(con)
                        $(".cart .cart__table-row").eq(index).each(function(){
                            $(this).find(".cart__remove").before("<ul class='ajaxcart_url ajaxcart__product-meta' style='margin:0;list-style: none;padding:0;'>"+con+"</ul>");
                        })
                    }

                  }
                });
          
              }
            }
        });
      },
      error: function(err){

      }
    });
    },
    error: function(err){
    }
  });
 $(document).on("change",".cart__qty-input",function(){
      setTimeout(function(){
        window.location.reload();
      },1000)
    
    });
    $(document).on(" input propertychange",".cart__qty-input",function(){
      setTimeout(function(){
        window.location.reload();
      },1000)
    })
    
    //三级联动
    $(document).on("click",".sufFather",function(){
      $(this).next(".suf-pro").toggleClass("hide")
        if($(this).children().children(".blod").text()=="+"){
          $(this).children().children(".blod").text("-")
        } else {
          $(this).children().children(".blod").text("+")
        }
    })
     //查看图片
    $(document).on("click",".lookImg",function(){
      let topH = document.documentElement.scrollTop+'px'
      console.log(top)
      if($(window).width()>800){
        $(".showPic3").css({"position":"fixed","top":$(window).scrollTop(),"left":0,"right":0,"margin":"0 auto","text-align":"center","max-width":"500px","padding":"20px 0"})
      } else{
      	$(".showPic3").css({"position":"fixed","top":"4%","left":0,"right":0,"margin":"0 auto","text-align":"center","max-width":"500px","padding":"20px 0"})
      }
      $(this).next(".model").removeClass("hide")
    })
    //隐藏图片
    $(document).on("click",".model",function(){
      $(this).addClass("hide")
    })
    
    //删除
//  $(document).on("click",".cart__remove",function(){
//    setTimeout(function(){
//      window.location.reload();
//    },500)
//  })